export const EMAIL_REQUIRED_ERROR = "Email is required";
export const EMAIL_INVALID_ERROR = "Email is invalid";

const MAX_EMAIL_LENGTH = 254;
const MAX_LOCAL_PART_LENGTH = 64;
const EMAIL_FORMAT_REGEX =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,63}$/;
const DOMAIN_LABEL_REGEX = /^[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/;

export function normalizeEmailAddress(email: string): string {
  return email.trim();
}

export function validateEmailAddress(email: string): string | null {
  if (!email.trim()) {
    return EMAIL_REQUIRED_ERROR;
  }

  const [localPart, domain, extraPart] = email.split("@");
  const hasValidLocalPart =
    Boolean(localPart) &&
    localPart.length <= MAX_LOCAL_PART_LENGTH &&
    !localPart.startsWith(".") &&
    !localPart.endsWith(".") &&
    !localPart.includes("..");
  const domainLabels = domain?.split(".") ?? [];
  const hasValidDomain =
    Boolean(domain) &&
    domainLabels.every(
      (label) =>
        label.length > 0 &&
        label.length <= 63 &&
        DOMAIN_LABEL_REGEX.test(label),
    );

  if (
    email.length > MAX_EMAIL_LENGTH ||
    extraPart !== undefined ||
    !hasValidLocalPart ||
    !hasValidDomain ||
    !EMAIL_FORMAT_REGEX.test(email)
  ) {
    return EMAIL_INVALID_ERROR;
  }

  return null;
}
